export { default as AuthModals, LoginModal, RegisterModal } from "./AuthModals";
